module.exports = "/images/Label.svg";